const NatUniData = [
    {
        thumb: '../img/natuni-thumb/nus-thumb.jpg',
        youtube: 'https://www.youtube.com/embed/o9_vX-sm7f8',
        img: '../img/natuni-thumb/nus-main.jpg',
        title: 'NUS',
        fullTitle: 'National University Of Singapore',
        student: '~31,760명',
        semester: '8월 중순',
        fee:'$S20,550',
        intro: '싱가포르대학교(National University of Singapore, NUS) 1905년 설립된 싱가포르 최초의 종합대학이며, 메인 캠퍼스는 싱가포르 남서부 지역의 켄트 릿지(Kent Ridge)에 위치해 있습니다. 아시아 태평양 대학 중 1위를 유지하며, 세계 우수대학 11위에 랭크 되었으며 미국의 동부 명문대학들(Ivy League)과 같은 수준의 초일류 대학으로 인정 받고 있습니다. 싱가포르를 운영하는 정부기관이나 입법, 사법, 행정의 최고위 관리들이 이 대학 출신들이 많이 있으며 싱가포르의 각 분야의 최고 엘리트 계층을 배출하는 명실공히 최고의 학교로 교수진의 50%는 외국 명문대 교수들로 구성되어 있습니다.'
    },
    {
        thumb: '../img/natuni-thumb/ntu-thumb.jpg',
        youtube: 'https://www.youtube.com/embed/4npS2JMGQa8',
        img: '../img/natuni-thumb/ntu-main.png',
        title: 'NTU',
        fullTitle: 'Nanyang Technological University Singapore',
        student: '24,759명',
        semester: '8월 중순',
        fee:'$S20,100',
        intro: '1981년에 설립된 싱가포르 난양 기술 대학교 (NTU Singapore)는 연구 중심의 공립 대학으로 공학, 경영, 과학 및 인문, 예술 및 사회 과학 대학, 대학원에 33,000 명의 학부 및 대학원생이 재학중이며  NTU의 Lee Kong Chian 의과 대학은 Imperial College London과 공동으로 설립되었습니다. 2019 년 NTU는 Quacquarelli Symonds (QS) 세계 대학 순위에서 11 위를 차지했으며 또한 2019 년 6 년 연속 QS에서 세계 최고의 젊은 대학 (50세 미만)으로 선정되었습니다. NTU 캠퍼스는 세계에서 가장 아름다운 15 대 대학 캠퍼스 중 하나이며 230 개 이상의 건물로 구성된 57 개의 Green Mark 인증 (LEED 인증) 건물 프로젝트를 보유하고 있으며 그 중 95 %가 Green Mark Platinum 인증을 받았습니다. 싱가포르 서부에 위치한 캠퍼스 외에도 NTU는 싱가포르의 의료 지구인 노비 나 (Novena) 중심부에 두번째 캠퍼스를 가지고 있습니다.'
    },
    {
        thumb: '../img/natuni-thumb/smu-thumb.jpg',
        youtube: 'https://www.youtube.com/embed/2BiCM1f7tWg',
        img: '../img/natuni-thumb/smu-main.jpg',
        title: 'SMU',
        fullTitle: 'Singapore Management University',
        student: '9,280명',
        semester: '8월 중순',
        fee:'$S24,500',
        intro: '2000년에 설립된 Singapore Management University는 경영대학으로서  현재 약 10,000 여명의 학부생과 대학원생이 재학중에 있으며 SMU의 교육목표는 전 세계에 영향을 미치는 창의적이고 기업가적인 광범위한 리더를 양성하는 것입니다. SMU 교수 는 미국, 유럽, 중국 및 인도의 주요 국제 연구원 및 대학과 협력하고 있으며 SMU의 도시 캠퍼스는 싱가포르 시내 중심부에 위치한 최첨단 시설로 비즈니스, 정부 및 더 넓은 지역 사회와의 전략적 연계를 촉진합니다. 싱가폴 최초로 민간 자본을 유치하여 설립된 최초의 사립대학이자 경영학 전문 단과 대학으로 미국의 유명한 비스니스 스쿨인 펜실베니아대 와튼스쿨(Pennsylvania University, Wharton School)을 모델로 하고 있습니다. 미국의 시카고 대학, 펜실베니아 대학 및 프랑스 ESSEC 등의 경영대학원 프로그램을 도입하여 교육을 실시하고 있으며, Associate of Corporate Treasures 등을 비롯한 8개의 기업 및 단체와 세계 각국의 30여개 업체와 산학협력 및 교육 프로그램을 실시하고 있습니다. 거의 실무에 가까운 수업방식과 MBA 배출생들의 활약 때문에 취업률 100%를 자랑하며 싱가폴 중심부에 최첨단 시설을 갖춘 현대적인 캠퍼스를 보유하고 있습니다.'
    },
    {
        thumb: '../img/natuni-thumb/suss-thumb.jpg',
        youtube: 'https://www.youtube.com/embed/OSA1rWwdeOg',
        img: '../img/natuni-thumb/suss-main.jpg',
        title: 'SUSS',
        fullTitle: 'Singapore University Of Social Science',
        student: '14,000명',
        semester: '8월 중순',
        fee:'$S30,500',
        intro: '2017년 설립된 6번째 싱가포르 국립대학교입니다. 1964년 싱가포르 경제개발청의 지원을 받아 설립된 SIM에 뿌리를 두고 있으며 SIM 고등교육 그룹에서 2005년 설립한 대학이 SIM University입니다. SIM GE와 SIM University로 나뉘어 운영되었으며 SIM GE는 영국, 미국, 호주 등의 해외 대학과 제휴하여 싱가포르 SIM GE 캠퍼스에서 대학 학위 과정을 이수하고 학위를 받는 구조라면 SIM University는 외국대학의 학위가 아닌 싱가포르 SIM University의 학위를 수여하는 차이점을 보입니다. SIM University를 사립학교에서 국립대학교로 승격을 약속하던 싱가포르 총리인 리센룽 (Lee Hsien Loong)은 2017년 7월 11일 공식적으로 SIM을 국립대학교로 재편성 하였고 동시에 학교 이름이 SIM University(UniSim)에서 SUSS로 변경되면서 본격적으로 정부의 지원을 받아 현재까지 운영되고 있습니다.'
    },
    {
        thumb: '../img/natuni-thumb/sit-thumb.jpg',
        youtube: 'https://www.youtube.com/embed/bnS9m111FmI',
        img: '../img/natuni-thumb/sit-main.jpg',
        title: 'SIT',
        fullTitle: 'Singapore Institute of Technology',
        student: '6,000명',
        semester: '8월 중순',
        fee:'$S29,730',
        intro: '싱가폴 국립전문대인 폴리테크닉과 해외대학들이 제휴하여 경제 발전에 기여할 수 있도록 연합제도를 최초로 도입되어 공대 (ENG), 화학공학 및 식품 기술(CEFT), 정보 통신 기술(ICT), 보건 및 사회 과학(HSS), 디자인 및 전문 비즈니스(DSB)의 5개 학부로 구성되어 있습니다. 2014년 싱가폴 의회에서 법안이 통과되어 5번째 국립대학교로써 자체 학위를 수여하기 시작했습니다.'
    },
    {
        thumb: '../img/natuni-thumb/sutd-thumb.jpg',
        youtube: 'https://www.youtube.com/embed/hK_XTOomwRU',
        img: '../img/natuni-thumb/sutd-main.jpg',
        title: 'SUTD',
        fullTitle: 'Singapore University of Technology and Design',
        student: '6,000명',
        semester: '8월 중순',
        fee:'$S53,200',
        intro: 'SUTD는 미국 MIT와의 협력으로 설립되었으며 MIT- SUTD교수들간의 1년간의 교환과정으로 MIT교수진에 의해 학업이 진행된다. MIT-SUTD공동석사과정을 제공하고 100%장학금 제공을 내세워 본격적인 아시아의 IT, 디자인 두뇌들의 입학을 기다리고 있는 싱가폴의 4번째 국립대학교이다. 리서치와 기술의 일반적인 맥락에 디자인과 혁신의 개념을 통합시킨 세계 최초의 대학으로써 지식허브와 싱가폴,아시아 그리고 세계를 위한 성장엔진이 되도록 SUTD를 추진할 환경을 만들기 위한 최고의 교수진,학생들 양성의 장을 마련할 것이다.'
    },
    
]

export default NatUniData
